import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { createAdmin } from '../redux/AdminSlice'
import {
    User,
    FileText,
    Briefcase,
    MapPin,
    Lock,
    Save
} from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Oval } from 'react-loader-spinner'

// Consistent role mapping with previous component
const ROLE_MAPPING = {
    users: { label: 'User Management', icon: User },
    reported_posts: { label: 'Content Moderation', icon: FileText },
    jobs: { label: 'Job Listings', icon: Briefcase },
    user_geolocation: { label: 'User Tracking', icon: MapPin },
    applicants: { label: 'Applicant Tracking', icon: Lock }
}

const AddAdmin = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        email: '',
        // password: '',
        // confirm_password: '',
        // status: 'active',
        roles: []
    })
    const [passwordError, setPasswordError] = useState('')
    const [isUpdating, setIsUpdating] = useState(false)

    // Handle input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target
        setFormData(prev => ({
            ...prev,
            [name]: value
        }))
    }

    // Handle role toggle
    const handleRoleToggle = (role) => {
        setFormData(prev => ({
            ...prev,
            roles: prev.roles.includes(role)
                ? prev.roles.filter(r => r !== role)
                : [...prev.roles, role]
        }))
    }

    // Form submission handler
    const handleSubmit = async () => {
        // Prepare data for submission
        const submitData = {
            first_name: formData.first_name,
            last_name: formData.last_name,
            email: formData.email,
            //   password: formData.password,
            //   status: formData.status,
            roles: JSON.stringify(formData.roles)
        }

        // Dispatch create admin action
        try {
            setIsUpdating(true)
            const result = await dispatch(createAdmin(submitData)).unwrap();
            // Check if the update was successful
            if (result) {
                toast.success('Admin added successfully')
                setFormData({
                    email:'',
                    first_name:'',
                    last_name:'',
                    roles:[]
                })
            }
        } catch (error) {
            console.error('Failed to update post status:', error);
            toast.error('An error occured');
        } finally {
            setIsUpdating(false)
        }
    };


    return (
        <div className="container mx-auto p-2 sm:p-6">
            <div className="mb-4">
                <button
                    onClick={() => navigate(-1)}
                    className="hover:underline"
                >
                    Go back
                </button>
            </div>
            <div className="rounded-lg overflow-hidden max-w-4xl mx-auto">
                <div className="px-6 py-4 border-b">
                    <h2 className=" text-lg sm:text-2xl font-bold text-gray-800">Create New Admin</h2>
                </div>

                <form className=" p-2 sm:p-6 space-y-4">
                    {/* Personal Information */}
                    <div className="grid md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-gray-700 mb-2">First Name</label>
                            <input
                                type="text"
                                name="first_name"
                                value={formData.first_name}
                                onChange={handleInputChange}
                                className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                required
                            />
                        </div>
                        <div>
                            <label className="block text-gray-700 mb-2">Last Name</label>
                            <input
                                type="text"
                                name="last_name"
                                value={formData.last_name}
                                onChange={handleInputChange}
                                className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                required
                            />
                        </div>
                    </div>

                    {/* Email and Password */}
                    <div className="grid md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-gray-700 mb-2">Email</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleInputChange}
                                className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                required
                            />
                        </div>
                        {/* <div>
              <label className="block text-gray-700 mb-2">Status</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleInputChange}
                className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </div> */}
                    </div>




                    {/* Role Management */}
                    {/* <div>
                        <h3 className="text-lg font-semibold mb-3">Assign Roles</h3>
                        <div className="grid md:grid-cols-2 gap-2">
                            {Object.entries(ROLE_MAPPING).map(([role, { label, icon: Icon }]) => (
                                <div
                                    key={role}
                                    className="flex items-center p-2 rounded-md hover:bg-gray-100 cursor-pointer"
                                    onClick={() => handleRoleToggle(role)}
                                >
                                    <input
                                        type="checkbox"
                                        checked={formData.roles.includes(role)}
                                        onChange={() => handleRoleToggle(role)}
                                        className="mr-3 h-4 w-4 text-blue-600 rounded focus:ring-blue-500"
                                    />
                                    <Icon className="mr-3 w-5 h-5 text-gray-500 text-xs sm:text-base" />
                                    <span>{label}</span>
                                </div>
                            ))}
                        </div>
                    </div> */}

                    {/* Submit Button */}
                    <div className="flex justify-end">
                        <button
                            onClick={handleSubmit}
                            type="button"
                            className="w-fit sm:w-fit font-lufga text-white bg-[#1330C5] hover:opacity-90 focus:outline-none rounded-md shadow-md text-base px-4 py-2 sm:px-10 sm:py-2 text-center transition-colors flex items-center"
                        >
                            <Save className="mr-2 w-5 h-5" />
                            {isUpdating ? (
                                <div className=" flex justify-center items-center">
                                    <Oval
                                        visible={true}
                                        height="20"
                                        width="20"
                                        color="#ffff"
                                        ariaLabel="oval-loading"
                                        wrapperStyle={{}}
                                        wrapperClass=""
                                    />
                                </div>
                            ) : 'Create Amdin'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )

}
export default AddAdmin